import VueDirective from '@/VueCore/directives/vueDirective';

function resizeElement(element: HTMLElement) {
  element.style.height = 'auto';
  element.style.height = element.scrollHeight + 'px';
}

class AutoResizeElement implements VueDirective {
  name = 'auto-resize';
  directive = {
    mounted(el, binding) {
      const isAutoResize = binding?.value ?? true;

      const resizeHandler = () => {
        resizeElement(el as HTMLElement);
      };
      el.__resizeHandler = resizeHandler;

      if (!isAutoResize) {
        return;
      }

      window.addEventListener('resize', resizeHandler);
      el.addEventListener('input', resizeHandler);

    },
    updated(el, binding) {
      const isAutoResize = binding?.value ?? true;
      if (!isAutoResize) {
        window.removeEventListener('resize', el.__resizeHandler);
        el.removeEventListener('input', el.__resizeHandler);
      } else {
        const resizeHandler = el.__resizeHandler;
        window.addEventListener('resize', resizeHandler);
        el.addEventListener('input', resizeHandler);
      }
    },
    unmounted(el) {
      window.removeEventListener('resize', el.__resizeHandler);
      el.removeEventListener('input', el.__resizeHandler);
    }
  };
}

export default new AutoResizeElement();